/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactV2 } from './ContactV2.js';
import {
    ContactV2FromJSON,
    ContactV2FromJSONTyped,
    ContactV2ToJSON,
} from './ContactV2.js';

/**
 * 
 * @export
 * @interface GetContactsResponse
 */
export interface GetContactsResponse {
    /**
     * 
     * @type {Array<ContactV2>}
     * @memberof GetContactsResponse
     */
    data?: Array<ContactV2>;
    /**
     * 
     * @type {number}
     * @memberof GetContactsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetContactsResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetContactsResponse interface.
 */
export function instanceOfGetContactsResponse(value: object): boolean {
    return true;
}

export function GetContactsResponseFromJSON(json: any): GetContactsResponse {
    return GetContactsResponseFromJSONTyped(json, false);
}

export function GetContactsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ContactV2FromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetContactsResponseToJSON(value?: GetContactsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ContactV2ToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

